import { useContext } from "react";

import LoadStatusContext from "./LoadStatusContext";

export const useLoadStatus = () => {
  return useContext(LoadStatusContext);
};
